import { Block, LabelMedium, useStyletron } from "@mezo-org/mezo-clay"

import { BitcoinToken } from "#/assets/icons"
import { StakingLockDurationType } from "#/shared/types"
import { bigIntToHumanReadableFormat, stakingUtils } from "#/shared/utils"

import StakingItemContainer from "./StakingItemContainer"

type StakedAmountItemProps = {
  amount: bigint
  lockDuration: StakingLockDurationType
  withLockDurationLabel?: boolean
}
export default function StakedAmountItem({
  amount,
  lockDuration,
  withLockDurationLabel = false,
}: StakedAmountItemProps) {
  const [css, theme] = useStyletron()

  return (
    <StakingItemContainer
      padding={theme.sizing.scale700}
      paddingRight={theme.sizing.scale600}
    >
      <Block
        className={css({
          display: "flex",
          flexDirection: "row",
          gap: theme.sizing.scale700,
        })}
      >
        <BitcoinToken size={24} />
        <LabelMedium>{bigIntToHumanReadableFormat(amount)} BTC</LabelMedium>
      </Block>

      {withLockDurationLabel && (
        <LabelMedium
          style={{
            color: theme.colors.contentSecondary,
            textTransform: "lowercase",
          }}
        >
          {stakingUtils.getLockDurationLabel(lockDuration)} lock
        </LabelMedium>
      )}
    </StakingItemContainer>
  )
}
